import React from 'react';
import { FunctionField } from 'react-admin';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';

const BlendedRateField = (props) => {
  return (
    <FunctionField
      render={(fields) => {
        const rateSettingsDisplayHelper = new RateSettingsDisplayHelper({
          location: fields.location,
          settings: fields[props.source],
          with_markup_settings: props.hasLocationTypeMarkup && fields.with_markup_settings,
        });
        const blendedRate = rateSettingsDisplayHelper.get12hRate(props.classification);

        if (!blendedRate || !props.hasBlendedRateMarkup) {
          return null;
        }

        return (blendedRate / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      }}
      sortable={false}
    />
  );
};

BlendedRateField.defaultProps = {
  label: 'Charge 12h rate',
  source: 'settings',
  classification: 'ten99',
  hasBlendedRateMarkup: true,
};

export default BlendedRateField;
